module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1-2@s",
    attrs: {
      "id": "left-menu"
    }
  }, [_c('h3', {
    staticClass: "uk-heading-line uk-text-center"
  }, [_c('span', [_vm._v("Menu")])]), _vm._v(" "), _c('ul', {
    staticClass: "uk-nav-primary uk-nav-parent-icon",
    attrs: {
      "uk-nav": ""
    }
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moje wizyty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("E-rejestracja")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Moje dane")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dokumenty do pobrania")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Strona kliniki LENS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96c58658","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/leftmenu.vue
// module id = 245
// module chunks = 1